import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decade',
  standalone: true,
})
export class DecadePipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    // Extrahiere das Jahr aus dem ISO-Datum
    const year = new Date(value).getFullYear();

    // Berechne das Jahrzehnt
    const decade = Math.floor(year / 10) * 10;

    return `${decade}er`;
  }
}
